import StatisticsPage from './StatisticsComponent';

export default StatisticsPage;
